export const SNAP_BEATS = Object.freeze({
  '1/4': 1,
  '1/8': 0.5,
  '1/16': 0.25,
  '1/32': 0.125,
  '1/8T': 1 / 3,
  '1/16T': 1 / 6,
  Off: null,
});

export const MUSICAL_KEY_OFFSETS = Object.freeze({ a: 0, w: 1, s: 2, e: 3, d: 4, f: 5, t: 6, g: 7, y: 8, h: 9, u: 10, j: 11, k: 12 });

export function musicalTypingPitch(key, octave = 3) {
  const offset = MUSICAL_KEY_OFFSETS[String(key || '').toLowerCase()];
  if (offset == null) return null;
  return Math.max(0, Math.min(127, 24 + Number(octave) * 12 + offset));
}

export function shiftTypingOctave(octave, key) {
  if (String(key).toLowerCase() === 'z') return Math.max(0, Number(octave) - 1);
  if (String(key).toLowerCase() === 'x') return Math.min(7, Number(octave) + 1);
  return Number(octave);
}

export function snapBeat(value, snapName) {
  const amount = typeof snapName === 'number' ? snapName : SNAP_BEATS[snapName];
  if (!amount) return Number(value);
  return Math.round(Number(value) / amount) * amount;
}

export function quantizeNotes(notes, { snap = '1/16', strength = 100, lengths = false, selectedIds = [] } = {}) {
  const amount = typeof snap === 'number' ? snap : SNAP_BEATS[snap];
  if (!amount) return (notes || []).map((note) => ({ ...note }));
  const selected = selectedIds instanceof Set ? selectedIds : new Set(selectedIds || []);
  const ratio = Math.max(0, Math.min(100, Number(strength))) / 100;
  return (notes || []).map((note) => {
    if (selected.size && !selected.has(note.id)) return { ...note };
    const targetStart = snapBeat(note.start, amount);
    const next = { ...note, start: note.start + (targetStart - note.start) * ratio };
    if (lengths) {
      const targetLength = Math.max(amount, snapBeat(note.length, amount));
      next.length = note.length + (targetLength - note.length) * ratio;
    }
    return next;
  });
}
